
angular.module('elogbooksServices').service('advancedFilterService', function (apiClient, lodash, $state, userManager, modulesService) {

    /**
     * Cancel a quote
     */
    this.getFilterData = function (collection, resources, extraParams = null) {
        switch (collection) {
            case 'audits':
                if (resources.user.getLink('audits')) {
                    let params = {};

                    return apiClient.get(resources.user.getLink('audits'), params);
                }
                break;
            case 'assets':
                if (resources.user.getLink('assets') && modulesService.isEnabled('assets_module')) {
                    let params = { order: 'name'};

                    return apiClient.get(resources.user.getLink('assets'), params);
                }
                break;
            case 'requisites':
                if (resources.rootResource.getLink('jobrequisites')) {
                    let params = {
                        active: 1,
                        order: 'name'
                    };

                    return apiClient.get(resources.rootResource.getLink('jobrequisites'), params);
                }
                break;
            case 'chargeTypes':
                if (resources.rootResource.getLink('chargetypes')) {
                    let params = { order: 'name' }

                    if ($state.params.chargeType) {
                        params.id = $state.params.chargeType;
                    }

                    return apiClient.get(resources.rootResource.getLink('chargetypes'), params);
                }
                break;
            case 'coreclients':
                    let params = {
                        active: 'yes',
                        order: 'name'
                    };

                    if (resources.rootResource.getLink('coreclients')) {
                        return apiClient.get(resources.rootResource.getLink('coreclients'), params).then( function(response) {
                            return response || {};
                        });
                    } else {
                        return {};
                    }
                break;
            case 'jobGroup':
                if (resources.rootResource.getLink('jobgroups')) {
                    return apiClient.get(resources.rootResource.getLink('jobgroups'), {limit: 30});
                }
                break;
            case 'job-operatives':
            case 'quote-operatives':
            case 'audit-operatives':
                if (resources.rootResource.getLink('operatives')) {
                    let params = collection === 'audit-operatives'
                    ? {}
                    : {
                        permission: collection === 'job-operatives' ? 'operative_permission_receive_jobs' : 'operative_permission_view_quotes',
                        limit: 30
                    };

                    return apiClient.get(resources.rootResource.getLink('operatives'), params);
                }
                break;
            case 'approvers':
                if (resources.user.getLink('users')) {
                    let params = {
                        membershipPermission: 'site_permission_can_be_approver',
                        order: 'name',
                        limit: 30
                    };

                    if (extraParams) {
                        params = angular.merge({}, params, extraParams);
                    }

                    return apiClient.get(resources.user.getLink('users'), params);
                }
                break;
            case 'quote-value-approvers':
                if (resources.user.getLink('users') && modulesService.isEnabled('quote_value_approval')) {
                    let params = {
                        order: 'name',
                        membershipPermission: 'site_permission_quote_value_approval',
                        excludeHelpDesk: true,
                        limit: 30
                    };

                    if (extraParams) {
                        params = angular.merge({}, params, extraParams);
                    }

                    return apiClient.get(resources.user.getLink('users'), params);
                }
                break;
            case 'jobServiceProviders':
            case 'fileServiceProviders':
            case 'quoteServiceProviders':
            case 'auditServiceProviders':
                if (resources.user.getLink('serviceproviders')) {
                    let params = { order: 'name'};

                    if (resources.selectedSiteResponse) {
                        params.site = resources.selectedSiteResponse.id;
                    }

                    return apiClient.get(resources.user.getLink('serviceproviders'), params);
                }
                break;
            case 'job-regions':
            case 'quote-regions':
                if (resources.user.getLink('regions')) {
                    let params = {};

                    return apiClient.get(resources.user.getLink('regions'), params);
                }
                break;
            case 'jobCreators':
                if (resources.user.getLink('users')) {
                    let params = {
                        includeJobCreators: 'true',
                        order: 'name'
                    };

                    return apiClient.get(resources.user.getLink('users'), params);
                }
                break;
            case 'quoteCreators':
                if (resources.user.getLink('users')) {
                    let params = {
                        includeQuoteCreators: 'true'
                    };

                    return apiClient.get(resources.user.getLink('users'), params);
                }
                break;
            case 'assetTypes':
                if (resources.rootResource.getLink('assettypes') && modulesService.isEnabled('assets_module')) {
                    let params = {
                        active: 1,
                        datagroup: 'search',
                        order: 'name'
                    };

                    return apiClient.get(resources.rootResource.getLink('assettypes'), params);
                }
                break;
            case 'sectors':
                if (resources.rootResource.getLink('sectors')) {
                    let params = {
                        order: 'name'
                    };

                    return apiClient.get(resources.rootResource.getLink('sectors'), params);
                }
                break;
            case 'siteGroups':
                if (resources.rootResource.getLink('sitegroups')) {
                    let params = { order: 'name'};

                    if ($state.params.siteGroups) {
                        params.id = $state.params.siteGroups;
                    }

                    return apiClient.get(resources.rootResource.getLink('sitegroups'), params);
                }
                break;
            case 'serviceProviderGroups':
                if (resources.rootResource.getLink('serviceprovidergroups')) {
                    let params = {
                        limit: 30,
                        order: 'name'
                    }
                    return apiClient.get(resources.rootResource.getLink('serviceprovidergroups'), params);
                }
                break;
            case 'sites':
                if (resources.rootResource.getLink('sites')) {
                    let params = {};

                    if ($state.params.siteIds) {
                        params["siteIds[]"] = $state.params.siteIds;
                    }

                    return apiClient.get(userManager.user.getLink('sites'), params);
                }
                break;
        }
    };
});
